import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { MonitoringComponent } from '../Monitor/Core/components/Monitoring/monitoring.component';
import { NewsroomComponent } from '../News/Newsroom/components/Newsroom/newsroom.component';
import { NewswireComponent } from '../News/Newswire/components/newswire/newswire.component';
import { AmplifyComponent } from '../Amplify/Core/components/Amplify/amplify.component';
import { AccountManagementComponent } from '../Admin/AccountManagement/components/account-management.component';
import { DiscoverComponent } from '../Discover/Core/components/Discover/discover.component';
import { SystemsNotificationsComponent } from '../Admin/SystemNotifications/components/SystemNotifications/systems-notifications.component';
import { PasswordResetComponent } from './components/PasswordReset/password-reset.component';
import { LoginComponent } from './components/Login/login.component';
import { LoginRouteGuard } from './components/Login/login.route.guard';
import { LogoutRouteGuard } from './components/Login/logout.route.guard';
import { ForgotPasswordComponent } from './components/ForgotPassword/forgot-password.component';
import { DistributionPlanComponent } from './components/DistributionPlans/distribution-plan.component';
import { TermsAndConditionsComponent } from './components/TermsAndConditions/terms-and-conditions.component';
import { ReportsComponent } from '../Reports/Core/components/Reports/reports.component';
import { MfaLoginComponent } from './components/MultiFactorAuthentication/mfa-login.component';
import { SsoLoginComponent } from './components/SsoLogin/sso-login.component';
import { LandingPageComponent } from 'app/LandingPage/components/LandingPage/landingPage.component';
import { VisibilityIntelligenceComponent } from '../VisibilityIntelligence/components/visibility-intelligence.component';
import { ViActivateGuard } from '../VisibilityIntelligence/routing/vi-activate.gaurd';
import { visibilityIntelligenceRoutes } from '../VisibilityIntelligence/routing/vi.routes';

@NgModule({
    imports: [
        RouterModule.forRoot([
            { path: '', redirectTo: 'Dashboard', pathMatch: 'full' },
            {
                path: 'Report',
                component: ReportsComponent,
                data: {title: 'Report.browserTitle'}
            },
            {
                path: 'Amplify',
                component: AmplifyComponent,
                data: {title: 'Amplify.browserTitle'}
            },
            {
                path: 'Discover',
                component: DiscoverComponent,
                data: {title: 'MediaRelations.browserTitle'}
            },
            {
                path: 'Newsroom',
                component: NewsroomComponent,
                data: {title: 'Newsroom.browserTitle'}
            },
            {
                path: 'Newswire',
                component: NewswireComponent,
                data: {title: 'Newswire.browserTitle'}
            },
            {
                path: 'AccountManagement',
                component: AccountManagementComponent,
                data: {title: 'AccountManagement.browserTitle'}
            },
            {
                path: 'Notifications',
                component: SystemsNotificationsComponent,
                data: {title: 'Notifications.browserTitle'}
            },
            {
                path: 'PasswordReset/:token',
                component: PasswordResetComponent,
                data: {title: 'PasswordReset.browserTitle'}
            },
            {
                path: 'ChangePassword',
                component: PasswordResetComponent,
                data: {title: 'PasswordReset.browserTitle'}
            },
            {
                path: 'SetPassword',
                component: PasswordResetComponent,
                data: {title: 'PasswordSet.browserTitle'}
            },
            {
                path: 'ForgotPassword',
                component: ForgotPasswordComponent,
                data: {title: 'PasswordReset.browserTitle'}
            },
            {
                path: 'MultiFactorAuthentication',
                component: MfaLoginComponent,
                data: {title: 'Mfa.browserTitle'}
            },
            {
                path: 'ssoLogin',
                canActivate: [LoginRouteGuard],
                component: SsoLoginComponent,
                data: {title: 'Sso.Login.browserTitle'}
            },
            ...['Login', 'login'].map(path => ({
                path: path,
                canActivate: [LoginRouteGuard],
                component: LoginComponent,
                data: {title: 'Login.browserTitle'}
            })),
            {
                path: 'login/oauth2/code',
                component: SsoLoginComponent,
            },
            {
                path: 'Logout',
                canActivate: [LogoutRouteGuard],
                component: LoginComponent,
                data: {title: 'Agility.browserTitle'}
            },
            {
                path: 'Terms',
                component: TermsAndConditionsComponent,
                data: {title: 'Agility.browserTitle'}
            },
            {
                path: 'Email-Packages',
                component: DistributionPlanComponent,
                data: {title: 'Agility.browserTitle'}
            },
            ...['Dashboard', 'dashboard'].map(path => ({
                path: path,
                component: LandingPageComponent,
                data: { title: 'Agility.browserTitle'}
            })),
            {
                path: 'visibility-intelligence',
                canActivate: [ViActivateGuard],
                component: VisibilityIntelligenceComponent,
                children: visibilityIntelligenceRoutes
            }
        ], { paramsInheritanceStrategy: 'always'})
    ],
    exports: [
        RouterModule
    ]
})
export class BootstrapRoutingModule {}
